export default __webpack_public_path__ + "static/media/PasoSpanish.7497fffc.jpg";